require("!!D:\\www\\kh_indesso_web\\node_modules\\script-loader\\addScript.js")(require("!!D:\\www\\kh_indesso_web\\node_modules\\raw-loader\\index.js!D:\\www\\kh_indesso_web\\node_modules\\tinymce\\plugins\\textcolor\\plugin.js"))


//////////////////
// WEBPACK FOOTER
// D:/www/kh_indesso_web/~/script-loader!D:/www/kh_indesso_web/~/tinymce/plugins/textcolor/plugin.js
// module id = ../../../../script-loader/index.js!../../../../tinymce/plugins/textcolor/plugin.js
// module chunks = 2